/**
 * @file CompanyCodeForm.js
 * @description A reusable component for entering and validating company code.
 */
import React, { useState, useEffect, useRef } from 'react';
import styles from './AuthPage.module.scss';
import { getText } from '../../i18n';

const CompanyCodeForm = ({
    onSubmit,
    initialCompanyCode = '',
    demoOnly = false,
}) => {
    const [companyCode, setCompanyCode] = useState(initialCompanyCode);
    const [companyCodeError, setCompanyCodeError] = useState(null);
    const companyCodeRef = useRef(null);

    useEffect(() => {
        if (!initialCompanyCode) {
            companyCodeRef.current?.focus();
        }
    }, [initialCompanyCode]);

    const handleCompanyCodeChange = event => {
        setCompanyCode(event.target.value);
        setCompanyCodeError(null);
    };

    const handleSubmit = event => {
        event.preventDefault();
        if (!companyCode.trim()) {
            setCompanyCodeError('Company Code is required');
        } else {
            onSubmit(companyCode);
        }
    };

    return (
        <div
            className={`text-left mb-4 form-container p-3 mt-3 ${styles.companyCodeForm}`}
        >
            <h2 className="iNGAGED-Typography-Heading3">
                {getText('msg_6b0e9ab6add8')}
            </h2>
            <small className="text-muted">
                {getText('msg_e3e3830a5223')}
            </small>

            <form onSubmit={handleSubmit} className="text-left pt-5">
                <div className="form-group mb-3">
                    <input
                        type="text"
                        className={`form-control ${companyCodeError ? 'is-invalid' : ''}`}
                        placeholder={getText('msg_3d70d687cb02')}
                        name="companyCode"
                        id="companyCode"
                        autoComplete="on"
                        onChange={handleCompanyCodeChange}
                        value={companyCode}
                        ref={companyCodeRef}
                    />
                    {companyCodeError && (
                        <div className="invalid-feedback">
                            {companyCodeError}
                        </div>
                    )}
                </div>
                <div className="form-group d-grid gap-2 col-10 mx-auto text-center pt-3">
                    <button
                        type="submit"
                        className="ing-button-primary-left mx-auto mb-3"
                        disabled={demoOnly}
                    >
                        {getText('msg_2dacf6595984')}
                    </button>

                    <p>
                        <i className="bi bi-envelope" />
                        {' '}
                        {getText('msg_97e2e9fd5798')}
                        {' '}
                        <a
                            onClick={e => {
                                if (demoOnly) {
                                    e.preventDefault();
                                    return;
                                }
                            }}
                            href={`/get-support${
                                companyCode ? `?companyCode=${companyCode}` : ''
                            }`}
                            className="pl-2"
                        >
                            {getText('msg_fe1a2922069b')}
                        </a>
                    </p>
                </div>
            </form>
        </div>
    );
};

export default CompanyCodeForm;
